export const curriculum = {
  // Header
  title: 'Curriculum Progress',
  subtitle: 'Level up steadily through the four stages: A → B1 → B2 → C',

  // Step display
  currentLevelLabel: 'Current Level',
  currentBadge: 'You are here',
  completedBadge: 'Completed',
  upcomingBadge: 'Upcoming',

  // Level descriptions
  levelADesc: 'Complete beginner. Learn basic vocabulary and grammar foundations.',
  levelB1Desc: 'Lower intermediate. Build everyday conversational fluency and expand vocabulary.',
  levelB2Desc: 'Professional level. Refine nuance and idiomatic expressions.',
  levelCDesc: 'Near-native fluency. Master advanced expression.',

  // Level-up transition (test + 2 reinforcement lessons)
  levelUpTitle: 'Level Up',
  levelUpDescription: '1 test + 2 weakness-reinforcement lessons with your tutor',

  // Progress metrics
  completedLessons: 'Completed Lessons',
  completedLessonsUnit: '',
  remainingLessons: 'Remaining Lessons',
  remainingLessonsUnit: '',
  levelTest: 'Level-Up Test',
  levelTestPassed: 'Passed',
  levelTestNotPassed: 'Not taken',
  weakAreasTitle: 'Areas to Reinforce',
  weakAreasEmpty: 'No weak areas recorded yet',

  // No subscription / remaining lessons unavailable
  noSubscription: 'Subscribe to a plan to start taking lessons',
  viewPlans: 'View Plans',

  // States
  loading: 'Loading...',
  loadError: 'Failed to load progress data. Please try again later.',
  retry: 'Reload',

  // Additional plan (placeholder)
  additionalTitle: 'Additional Plans',
  additionalBadge: 'Coming Soon',
  additionalSubtitle: 'Specialized courses you can choose after completing levels A–C. We will let you know once they are ready.',
  additionalWorkplace: 'Workplace Courses',
  additionalWorkplaceDesc: 'Phrases for work settings like kitchen, hotel, and customer service',
  additionalWordplay: 'Wordplay Courses',
  additionalWordplayDesc: 'Abbreviations, proverbs, and slang',
  additionalComingSoon: 'In preparation',
  additionalSelectPlaceholder: 'Select a course (coming soon)',
};
